import { useId } from 'react';
import { Link } from 'react-router';

import { formatVnd } from '../../../shared/lib/money.js';
import lists from '../../../shared/styles/lists.module.css';
import { usePendingEntries } from '../hooks/usePendingEntries.js';
import styles from './PendingCard.module.css';

/**
 * "Chờ duyệt" on Trang chủ (AL1): bank notices that arrived by email and are not on the books
 * yet. Sits with "Đến hạn" above the month's figures for the same reason — none of this is in
 * the report until a person approves it.
 *
 * Silent while loading and on error: Home must never break because the inbox could not be
 * read (for instance when the web app is deployed before migration 0023 reaches the database).
 */
export function PendingCard() {
  const headingId = useId();
  const state = usePendingEntries();

  if (state.status !== 'ready' || state.inbox.count === 0) return null;
  const { count, total } = state.inbox;

  return (
    <section className={lists.card} aria-labelledby={headingId}>
      <h2 className={lists.cardTitle} id={headingId}>
        Chờ duyệt
      </h2>
      <Link className={lists.rowLink} to="/cho-duyet">
        <span className={lists.rowText}>
          <span className={lists.rowName}>{count} khoản từ email ngân hàng</span>
          <span className={lists.rowMeta}>Chưa vào sổ — duyệt để ghi</span>
        </span>
        <span className={styles.right}>
          <span className={lists.amount}>{formatVnd(total)}</span>
          <span className={lists.chevron} aria-hidden="true">
            ›
          </span>
        </span>
      </Link>
    </section>
  );
}
